// e2e test helper to help verify if this is in studio
window["isInStudio"] = true;

export {};
